import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../store/use-thunk-dispatch';

export const SUPPLIER_SPECIAL_OFFERS_DELETED = 'SUPPLIER_SPECIAL_OFFERS_DELETED';

export const supplierSpecialOffersDeleted = (id: number) => {
    return {
        type: SUPPLIER_SPECIAL_OFFERS_DELETED,
        id,
    };
};

export const deleteSupplierSpecialOffers = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(supplierSpecialOffersDeleted(id));

        const response = await api.contentManagement.SupplierSpecialOffers.deleteSupplierSpecialOffers(id);

        if (!response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
